export const APP_NAME = process.env.REACT_APP_SITE || 'flow';

export const TESTE = 'teste';
